@if (isLoading) {
	<div class="text-center p-3">
		<i class="fa fa-spinner fa-spin fa-2x"></i>
	</div>
} @else {
<div>
	<div class="mb-2 p-2 pb-0">
		<ejs-dropdownlist
			[dataSource]="roles"
			[(ngModel)]="selectedRoleId"
			(ngModelChange)="onRoleFilterChange()"
			placeholder="All Roles"
			[showClearButton]="true"
			data-test-id="assigneeRoleFilter">
		</ejs-dropdownlist>
	</div>

	<div class="px-2 pb-2">
		<div class="p-1 border-bottom border-top position-relative">
			<div class="input-group">
				<span class="input-group-text"><i class="fa fa-search fa-lg"></i></span>
				<input
					type="text"
					class="form-control"
					placeholder="Search"
					[(ngModel)]="searchText"
					(input)="onSearchChange()"
					data-test-id="assigneeSearch"/>
			</div>
			@if (searchText) {
				<button
					type="button"
					class="btn p-0 border-0 bg-transparent position-absolute top-50 translate-middle-y shadow-none search-clear-btn"
					(click)="clearSearch()"
					data-test-id="assigneeClearSearch">
					<i class="fa fa-times"></i>
				</button>
			}
		</div>

		<table class="table table-sm table-bordered mb-0">
			<thead>
				<tr class="bg-light">
					<th style="width: 30px;" class="text-center align-middle">
						<input
							type="checkbox"
							class="form-check-input m-0"
							[checked]="allVisibleSelected"
							(change)="toggleSelectAll()"
							data-test-id="assigneeSelectAllCheckbox"/>
					</th>
					<th class="fw-normal">Name</th>
				</tr>
			</thead>
		</table>
		<div class="overflow-auto" style="max-height: 250px;">
			<table class="table table-sm table-bordered mb-0">
				<tbody>
					@for (employee of displayedEmployees; track employee.value) {
						<tr [class.table-info]="isSelected(employee)">
							<td style="width: 30px;" class="text-center align-middle">
								<input
									type="checkbox"
									class="form-check-input m-0"
									[checked]="isSelected(employee)"
									(change)="toggleEmployee(employee)"
									[attr.data-test-id]="'assigneeCheckbox-' + employee.value"/>
							</td>
							<td>{{ employee.label }}</td>
						</tr>
					} @empty {
						<tr>
							<td colspan="2" class="text-muted text-center">No employees found</td>
						</tr>
					}
				</tbody>
			</table>
		</div>

		<div class="d-flex align-items-center gap-2 mt-2">
			<input
				id="requireAllAssignees"
				type="checkbox"
				class="form-check-input m-0"
				[(ngModel)]="requireAll"
				(ngModelChange)="onRequireAllChange()"
				data-test-id="assigneeRequireAll"/>
			<i class="fa fa-info-circle text-primary"
				revTooltip
				tooltipContent="Check this box to create a copy of this Task for EVERY employee you checked. Otherwise, only one employee can accept the Task and will need to complete it. After someone accepts the Task, it will be removed from everyone else's list of potential Tasks.">
			</i>
			<label
				class="form-check-label"
				for="requireAllAssignees">
				Require all assignees to complete this task
			</label>
		</div>
	</div>
</div>
}
